var __variants;
$(document).ready(function() {
  //Geneare the discounts table
  let key_array = [];
  let tmp = [];
  let price_array = [];
  for( let key in __discount_breaks ){
    key_array.push( parseInt(key) );
    price_array.push( (__price - __discount_breaks[key]) );
  }
  //console.log(key_array);
  for( let key=0; key<key_array.length; key++ ){
    let current_key = "";
    //if( key_array[key+1]!=undefined ) current_key = key_array[key]+"-"+(key_array[key+1]-key_array[key]);
    if( key_array[key+1]!=undefined ) current_key = key_array[key]+"-"+(key_array[key+1]-1);
    else current_key = key_array[key]+"+";
    tmp.push(current_key);
  }
  key_array = tmp;
  for( let key in key_array ){
    $("#price_discounts_table").find("thead").find("th").last().before("<th>"+key_array[key]+"</th>");
  }
  for( let key in price_array ){
    $("#price_discounts_table").find("tbody").find("td").last().before("<td>$ "+price_array[key]+"</td>");
  }
  
  //Render thumbnail
  let color_option_index = $("[data-option-color]").data("option-index");
  __variants = JSON.parse( $("#variants_json").html() );
  //console.log( __variants );
  $(".product-form__input").find("label[data-color]").each(function(){
    let color = $(this).data("color");
    let variant = getVariantByColor(color,color_option_index);
    let thumbnail = getThumbnailURL(variant.featured_image.src , '50x');
    $("label[data-color='"+color+"']").html("<img src='"+thumbnail+"'/>");
    $("label[data-color='"+color+"']").attr("data-id",variant.id);
  });
  
  $("label.thumbnail").on('click',function(){
    initialQuantityBoxMax( $(this).data("id") );
  });
  
  //Try to refresh the icon
  window.dispatchEvent( new CustomEvent("__cart_updated", {detail: null}) );
});

function inputQuantityCheck(obj){
  let max_value = $(obj).attr("max");
  if( parseInt($(obj).val()) > max_value ) $(obj).val(max_value);
}

function initialQuantityBoxMax(id){
  if( typeof __variants_qty_table[id] == "undefined" ) return;
  let max_value = __variants_qty_table[id];
  $("#quantity").attr("max",max_value);
}

function getVariantByColor(color,index){
  for( let key in __variants ){
    if( __variants[key]["option"+index]==color ){
      return __variants[key];
      break;
    }
  }
}

function getThumbnailURL(url,dimension){
  if( url.indexOf(".jpg")>-1 ) url = url.replace(".jpg","_"+dimension+".jpg");
  else if( url.indexOf(".png")>-1 ) url = url.replace(".png","_"+dimension+".png");
  else if( url.indexOf(".jpeg")>-1 ) url = url.replace(".jpeg","_"+dimension+".jpeg");
  return url;
};

function addToCartWithCustomDiscount(pid){
  let quantity = $("#quantity").val();
  if( quantity<=0 ){
    //alert("Please input the quantity");
    //toastr.warning('Please input the quantity');
    $("#quantity").focus();
    Swal.fire({
      icon: 'warning',
      title: 'Tip',
      text: 'Please input the quantity',
      timer: 4000
    });
    return;
  }
  let vid = $("[name='id']").val();
  
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: quantity,  
      id: vid, //Variant ID
    },
    dataType : 'json',
    success: function(e){
      //Return the added item data
      //console.log(e);
      //Swal.fire('Added');
      $("#quantity").val(0);
      
      window.dispatchEvent( new CustomEvent("__cart_updated", {detail: null}) );
      
      //toastr.success('Added');
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Added',
        timer: 2000
      });
      
    },
  });
}